export default __webpack_public_path__ + "static/media/fullscreen.dc52b792.svg";